"use client";

import { Typography } from "@/components/custom/typography";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";
import { useTypedTranslations } from "@/i18n/typed";

type SuggestionKey =
  | "audience"
  | "audiencePlace"
  | "weekdayTime"
  | "timePlace"
  | "displayType"
  | "shoppingMall";

interface SuggestionsProps {
  onSelected: (value: string) => void;
  className?: string;
}

const SUGGESTION_KEYS: {
  key: SuggestionKey;
  isHighlight: boolean;
}[] = [
  { key: "audience", isHighlight: false },
  { key: "audiencePlace", isHighlight: false },
  { key: "weekdayTime", isHighlight: false },
  { key: "timePlace", isHighlight: false },
  { key: "displayType", isHighlight: false },
  { key: "shoppingMall", isHighlight: false },
];

export function Suggestions({ onSelected, className }: SuggestionsProps) {
  const t = useTypedTranslations("searchAIChat");

  return (
    <ScrollArea className={className}>
      {SUGGESTION_KEYS.map(({ key, isHighlight }, idx) => (
        <div
          key={`${key}-${idx}`}
          className="border border-gray-300 rounded-xl mb-1 py-2 px-4 cursor-pointer"
          onClick={() => onSelected(t(`suggestions.items.${key}.value`))}
        >
          <Typography
            variant="body2"
            className={cn(
              isHighlight ? "text-primary" : "text-gray-800 font-semibold",
            )}
          >
            {t(`suggestions.items.${key}.title`)}
          </Typography>

          <Typography as="span" variant="detail1" className="text-gray-700">
            {t(`suggestions.items.${key}.value`)}
          </Typography>
        </div>
      ))}
    </ScrollArea>
  );
}
